import { VStack, Box, Col, Row, Select, Flex, Text } from "@reverb-ui/react";
import { useContext, useState } from "react";
import { MetricCard } from "../../components/MetricCard";
import { DayPartingContext } from "../context-api";
import { DayPartingTable, MetricType } from "./DayPartingTable";
import { DayPartingTableSkeleton } from "../../components/Skeleton/DayPartingTableSkeleton";
import { IconVariationEnum } from "data/constants/constants";
import { ListCardSkeleton } from "../../components/Skeleton/CardSkeleton";
import { panelsInfo } from "helper/panelsHelper";
import PanelContainer from "presentation/components/PanelContainer";

const dayPartingInfo = panelsInfo.dayParting;

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),
};

export const DayPartingReports = () => {
  const [metric, setMetric] = useState<MetricType>("Respondents");
  const { requestParamsIndex, dayPartingData, isLoading } =
    useContext(DayPartingContext);
  const { downloadingReports, downloadDayPartingCSV } =
    useContext(DayPartingContext);

  return (
    <PanelContainer
      panelId={dayPartingInfo.htmlId}
      panelName={dayPartingInfo.description}
      rangeName={dayPartingData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadDayPartingCSV,
        downloadingReports: downloadingReports,
        panelInfo: dayPartingInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col col={3}>
          {isLoading ? (
            <ListCardSkeleton
              numberOfCards={2}
              spacingBetween={5}
              hasSubText={true}
              hasVariationPeriod={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              <Flex gap={2} w="100%" pl={2} align="center">
                <Text color="gray.700" fontSize="md">
                  Metric:
                </Text>
                <Select
                  styles={customStyles}
                  options={[
                    { value: "Respondents", label: "Respondents" },
                    { value: "Conversion", label: "Conversion" },
                  ]}
                  placeholder="Metric"
                  value={{ value: metric, label: metric }}
                  onChange={(value) => setMetric((value as any).value)}
                />
              </Flex>
              {dayPartingData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  variation={item.percentageVariation}
                  variationPeriod={item.previousRange}
                  variationType={item.iconVariation as IconVariationEnum}
                  subDescription={item.subText}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col col={9}>
          <Box bg="white" w="full" p={6}>
            {isLoading ? (
              <DayPartingTableSkeleton />
            ) : (
              dayPartingData && (
                <DayPartingTable
                  daysPartingData={dayPartingData.dayPartings}
                  metric={metric}
                />
              )
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
